var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8998AA",
    fillRule: "evenodd",
    d: "M9 9.867H6.997c-.544 0-.997.448-.997 1 0 .557.446 1 .997 1H9v2.003c0 .544.448.997 1 .997.556 0 1-.446 1-.997v-2.003h2.003c.544 0 .997-.447.997-1 0-.556-.446-1-.997-1H11V7.864c0-.543-.448-.997-1-.997-.556 0-1 .447-1 .997v2.003z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic-plus.63fb93effafb09d4e2a524ca0c8c70cb.svg";
export { ForwardRef as ReactComponent };